import { render } from "./productsViewFullKit.vue?vue&type=template&id=69f1ae98"
import script from "./productsViewFullKit.vue?vue&type=script&lang=js"
export * from "./productsViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__